import { render, staticRenderFns } from "./Statics.vue?vue&type=template&id=e456c280&scoped=true&"
import script from "./Statics.vue?vue&type=script&lang=js&"
export * from "./Statics.vue?vue&type=script&lang=js&"
import style0 from "./Statics.vue?vue&type=style&index=0&id=e456c280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e456c280",
  null
  
)

export default component.exports